import { render } from "./NewUser.vue?vue&type=template&id=b63bbb58"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"

import "./NewUser.vue?vue&type=style&index=0&id=b63bbb58&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__